export const TRACKING_GAP_MS = 2 * 60 * 1000

export function position(value) {
  if (value?.latitude == null || value?.longitude == null || String(value.latitude).trim() === "" || String(value.longitude).trim() === "") return null
  const lat = Number(value.latitude), lng = Number(value.longitude)
  return Number.isFinite(lat) && Number.isFinite(lng) && Math.abs(lat) <= 90 && Math.abs(lng) <= 180 ? { lat, lng } : null
}

export function recordedJourney(rows) {
  const points = rows.flatMap(row => {
    const coordinate = position(row), time = Date.parse(row.captured_at)
    return coordinate && Number.isFinite(time) ? [{ ...row, position: coordinate, time }] : []
  }).sort((a, b) => a.time - b.time || String(a.id).localeCompare(String(b.id), "en", { numeric: true }))
  const segments = []
  for (let i = 0; i < points.length; i++) {
    const previous = points[i - 1], current = points[i]
    if (!previous || previous.session_id !== current.session_id || current.time - previous.time > TRACKING_GAP_MS) segments.push([])
    segments.at(-1).push(i)
  }
  return { points, segments }
}

// Keep the last recorded position until the next sample. Do not invent GPS
// movement, particularly through a session change or a long tracking gap.
export function sampleAt(points, time) {
  if (!points.length) return -1
  let low = 0, high = points.length
  while (low < high) {
    const middle = Math.floor((low + high) / 2)
    if (points[middle].time <= time) low = middle + 1
    else high = middle
  }
  return Math.max(0, low - 1)
}

export function isTrackingGap(points, index, time) {
  const current = points[index], next = points[index + 1]
  return !!(current && next && time > current.time && time < next.time &&
    (current.session_id !== next.session_id || next.time - current.time > TRACKING_GAP_MS))
}
